import { Injectable, signal } from '@angular/core';

/**
 * UI state for the feature-layer details panel: which feature layer's
 * details (legend + actions) is currently opened over the layers panel.
 */
@Injectable({ providedIn: 'root' })
export class FeatureLayerDetailsService {
  private readonly _selectedKey = signal<string | undefined>(undefined);
  readonly selectedKey = this._selectedKey.asReadonly();

  open(key: string) {
    this._selectedKey.set(key);
  }

  close() {
    this._selectedKey.set(undefined);
  }
}
